// extracted by mini-css-extract-plugin
export var dek = "subhed-module--dek--MXiCQ";
export var mb = "subhed-module--mb--odvrA";
export var subhed = "subhed-module--subhed--viEAG";